import React from "react";

import withPriceAlertsModal from "../../../../../hocs/withPriceAlertsModal";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import EditIcon from "../../../pages/SingleAnalysisPage/components/PriceAlertsTable/assets/edit.svg";
import TrashIcon from "../../../pages/SingleAnalysisPage/components/PriceAlertsTable/assets/trash.svg";

import "./ActionPriceAlert.scss";

function pickRowFields(resultMetaData, value) {
  if (!resultMetaData || typeof resultMetaData !== "object") {
    return { stockId: null, alertId: null, price: undefined, comment: "" };
  }

  const { id: alertId, stockId: stock_id } = value || {};
  const stockId = stock_id ?? value?.stock_id ?? null;

  const descriptionRaw =
    resultMetaData.description ?? resultMetaData.comment ?? "";
  const comment =
    typeof descriptionRaw === "string"
      ? descriptionRaw
      : String(descriptionRaw ?? "");

  const stockNameRaw =
    resultMetaData.company_name ?? resultMetaData.companyName ?? "";
  const stockName =
    typeof stockNameRaw === "string" ? stockNameRaw.trim() : undefined;

  return {
    stockId,
    alertId,
    price: resultMetaData.price,
    comment,
    stockName
  };
}

const ActionPriceAlert = ({ resultMetaData, value, removeAlert }) => {
  const { stockId, alertId, price, comment, stockName } = pickRowFields(
    resultMetaData,
    value
  );

  const openEditModal = () => {
    showModal("NewPriceAlertsModal", {
      stockId,
      price,
      description: comment,
      editingAlertId: alertId,
      stockName
    });
  };

  const onDelete = () => {
    removeAlert({ id: alertId, stockId });
  };

  return (
    <div className="action-price-alert">
      <button
        type="button"
        className="action-price-alert__btn"
        onClick={openEditModal}
        aria-label="Edit price alert"
      >
        <img src={EditIcon} alt="" width={16} height={16} />
      </button>
      <span className="action-price-alert__divider" aria-hidden />
      <button
        type="button"
        className="action-price-alert__btn"
        onClick={onDelete}
        aria-label="Delete price alert"
      >
        <img src={TrashIcon} alt="" width={16} height={16} />
      </button>
    </div>
  );
};

export default withPriceAlertsModal(ActionPriceAlert);
